<template>
    <div class="consent gdpr-container">
        <h4 class="consent__title">Modificare Consimtamant</h4>
        <p class="consent__description">Trimite solicitarea ta completand formularul de mai jos</p>
        <form class="consent__form">
            <div class="form-row">
                <div class="col-12 col-sm-6">
                    <input type="email" class="form-control" placeholder="Email" v-model="email">
                </div>
                <div class="col-12 col-sm-3 consent__btn-container">
                    <button class="btn btn-primary call-to__button mr-2" @click.prevent="sendMail">Trimite</button>
                </div>
            </div>
            
            <div class="error text-danger mt-3" v-if="errorMessage !== ''">
                <p class="error__text mb-1"> {{ errorMessage }} </p>
            </div>
            
            <div class="success text-success mt-3" v-if="successMessage !== ''">
                <p class="success__text mb-1"> {{ successMessage }} </p>
            </div>
        </form>
    </div>      
</template>

<script>
    import GlobalService from './../../services/Global'
    export default {
        data () {
            return {
                email: '',
                successMessage: '',
                errorMessage: ''
            }
        },
        created () {
            GlobalService.goToTop()
        },
        methods: {
            sendMail() {
                this.successMessage = ''
                this.errorMessage = ''
                
                if (this.email.trim() == '') {
                    this.errorMessage = 'Va rugam completati adresa de email'
                    return;
                }
                else if (this.email.trim() != '' && !(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email))) {
                    this.errorMessage = 'Email invalid.'
                    return;
                }

                this.$http.post(`/modifyConsents`,
                {
                  email: this.email
                }).then(response => {
                    if(response.data.success) {
                        this.successMessage = response.data.success
                        setTimeout(() => {this.successMessage = ''}, 3000)
                    } 
                    else {
                        this.errorMessage = response.data.error
                        setTimeout(() => {this.errorMessage = ''}, 3000)
                    }
                })
                .then(() => {
                    this.email = ''
                })
                .catch(e => console.log(e))
            }
        }
    }
</script>